<template>
  <section class="section-login">
    <div class="container">
      <div class="col-11 mx-auto mb-4" v-if="verifytoken==0">
        <input type="text" placeholder="Username" class="form-control mb-3" v-model="username" />
        <input type="password" class="form-control mb-4" placeholder="Password" v-model="password" />
        <button class="btn btn-primary w-100" @click="doLogin()">Login</button>
      </div>
      <div class="col-11 text-center" v-else>Verifing user ....</div>
    </div>
  </section>
</template>
<script>
import { BASEURL } from "@/config/index";
let BaseURL = BASEURL;
import axios from "axios";
export default {
  name: "Index",
  data() {
    return {
      username: "",
      password: "",
      verifytoken: 0
    };
  },
  components: {},
  beforeMount() {
    let token = $cookies.get("token");
    if (token) {
      this.verifytoken = 1;
      axios
        .post(`${BaseURL}/verifytoken`, {
          token: token
        })
        .then(
          response => {
            console.log(response);
            if (response && response.data && response.data["status"]) {
              this.$cookies.set("token", response.data["token"]);
              this.$router.push({ name: "scanPage" });
            } else {
              console.log("Api error");
              this.verifytoken = 0;
              this.$cookies.remove("token");
            }
          },
          error => {
            console.log(error);
            this.verifytoken = 0;
            this.$cookies.remove("token");
          }
        );
    }
  },
  mounted() {
    //read cookies
  },
  methods: {
    doLogin: function() {
      this.verifytoken = 1;
      axios
        .post(`${BaseURL}/applogin`, {
          username: this.username,
          password: this.password
        })
        .then(
          response => {
            console.log(response);
            if (response && response.data && response.data["status"]) {
              $cookies.set("token", response.data["token"]);
              this.$router.push({ name: "scanPage" });
            } else {
              console.log("Api error");
              this.verifytoken = 0;
            }
          },
          error => {
            console.log(error);
            this.verifytoken = 0;
          }
        );
    }
  }
};
</script>
<style>
.section-login {
  display: flex;
  position: relative;
  align-items: center;
  height: calc(100vh - 47px);
}
</style>


// WEBPACK FOOTER //
// src/components/pages/login.vue